export default __webpack_public_path__ + "static/media/img-0052.c1d45ed9.png";